import { useRef } from 'react'
import styled from 'styled-components'

import { colors, zIndex } from '@/styles'
import { CloseIcon } from '@/components/icons'
import ListingCard from '@/components/listing-card'
import LockedListingCard from '@/components/listing-card/locked-listing-card'

const Wrapper = styled.div`
  width: 100%;
  bottom: 62px;
  left: 0;
  justify-content: center;
  align-items: center;
  position: absolute;
  max-width: 100vw;
  z-index: ${zIndex.mapCarousel};
  padding: 0px 16px;
`

const StyledListingCard = styled(ListingCard)`
  width: 100%;
  max-width: 100vw;
  transition: unset;
`

const CloseButton = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -36px;
  right: 16px;
  z-index: 2;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  background: ${colors.regular};
  svg {
    flex-shrink: 0;
    path {
      fill: ${colors.white};
    }
  }
`

const MapListingCarousel = ({
  data = {},
  handleClose,
  isCardLocked = false
}) => {
  const listingCardRef = useRef()

  if (!data.listing_id) return null

  return (
    <Wrapper ref={listingCardRef}>
      <CloseButton aria-label="Close" onClick={handleClose}>
        <CloseIcon width={16} height={16} />
      </CloseButton>
      {isCardLocked ? (
        <LockedListingCard listing={data} isRow={false} favouriteButton />
      ) : (
        <StyledListingCard
          listing={data}
          tooltip="left"
          newTab
          noSchema
          favouriteButton
        />
      )}
    </Wrapper>
  )
}

export default MapListingCarousel
